import { useEffect, useRef, useState } from "react";
import { api } from "./api";

const KEY = "jawsel_pesan_dilihat"; // ISO waktu pesan terbaru yang sudah dilihat warga di HP ini

// Lencana "pesan baru": true bila ada pesan publik lebih baru dari kunjungan terakhir (cek saat buka + tiap 60 dtk).
// Saat sheet Pesan dibuka → tandai sudah dilihat.
export function usePesanBaru(sheetOpen) {
  const [baru, setBaru] = useState(false);
  const latestRef = useRef(null);

  useEffect(() => {
    let alive = true;
    const cek = () => api.publicPesan().then(d => {
      const latest = d.pesan?.[0]?.created_at || null;
      latestRef.current = latest;
      const dilihat = localStorage.getItem(KEY);
      if (alive) setBaru(!!latest && (!dilihat || latest > dilihat));
    }).catch(() => {});
    cek();
    const t = setInterval(cek, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  useEffect(() => {
    if (!sheetOpen) return;
    localStorage.setItem(KEY, latestRef.current || new Date().toISOString());
    setBaru(false);
  }, [sheetOpen]);

  return baru;
}
